import { render, staticRenderFns } from "./resourceCard.vue?vue&type=template&id=38933028&scoped=true"
import script from "./resourceCard.vue?vue&type=script&lang=js"
export * from "./resourceCard.vue?vue&type=script&lang=js"
import style0 from "./resourceCard.vue?vue&type=style&index=0&id=38933028&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38933028",
  null
  
)

export default component.exports